import ReadOnlyField from "../attributes/compare-table/read-only-field";
import { BVQaColumn } from "./bv-qa-column";

export const DisplayValues = ({ task, role, attr, status, onStatusChange, onUpdateAttribute, onAttrList, refreshAttributeGroups, isCompleted }) => {
    if (role.type !== "qa") {
        return (
            <div className="coder-attributes-container">
                <ReadOnlyField
                    id={attr.uuid}
                    value={role.values?.[attr.uuid]}
                    defaultValue={null}
                    attribute={attr}
                    wipKey={null}
                    taskType={task.taskType}
                    roleType={role.type}
                    roleLabel={role.label}
                />
            </div>
        );
    }

    return (
        <BVQaColumn
            isSupplierAttribute={attr.additionalInfo?.isSupplierAttribute}
            attrGroup={attr.sortGroup.name}
            attrName={attr.name}
            attrNote={attr.additionalInfo?.approvalNote}
            uuid={attr.uuid}
            status={status}
            onUpdateStatus={onStatusChange}
            onUpdateAttribute={onUpdateAttribute}
            onAttrList={onAttrList}
            refreshAttributeGroups={refreshAttributeGroups}
            isCompleted={isCompleted}
        />
    );
};
